<script>
  import { onMount } from "svelte";
  import { _ } from "@services/i18n";
  import { supportsVoice } from "@utils/support";
  import { FADE_DURATION } from "../consts";

  export let text;

  let hidden = null;
  let textarea = null;

  onMount(() => {
    handleFocus();
  });

  /**
   * Temporarily focus on hidden input,
   * then once transition duration has
   * passed, switch focus to text area.
   *
   * Fixes iOS bug whereby keyboard shows
   * above the input.
   */
  function handleFocus() {
    hidden.focus();
    setTimeout(() => {
      textarea.focus();
    }, FADE_DURATION * 1.1);
  }
</script>

<style>
  .spacer {
    align-items: stretch;
    flex: 1;
    margin-right: 1.5em;
    position: relative;
    vertical-align: top;
  }

  .spacer::after {
    content: attr(data-padding) " ";
    visibility: hidden;
    white-space: pre-wrap;
  }

  :global(.enhanced) .spacer {
    bottom: 2rem;
    box-sizing: border-box;
    flex: none;
    font-size: 1.6rem;
    height: auto;
    left: 1rem;
    line-height: 1.5;
    margin: 0;
    min-height: 5rem;
    max-height: calc(100vh - 4rem);
    padding: 1.35rem 1.6rem;
    pointer-events: auto;
    position: absolute;
    right: 6.8rem;
    text-align: left;
  }

  .supportsVoice {
    left: 6.8rem!important;
  }

  textarea {
    appearance: none;
    border: 0;
    border-radius: 4px;
    box-shadow: 0 0 16px var(--thin-shadow);
    display: block;
    font-family: -apple-system, "Arial", sans-serif;
    font-size: 1.6rem;
    height: 100%;
    line-height: 1.25;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1rem 1.6rem 0;
    resize: none;
    text-align: left;
    width: 100%;
  }

  :global(.enhanced) textarea {
    bottom: 0;
    left: 0;
    line-height: 1.5;
    min-height: 5rem;
    padding: 1.35rem 1.6rem;
    position: absolute;
  }

  .hidden {
    position: absolute;
    top: 0;
    transform: translateX(-1000px);
  }
</style>

<div class="spacer" class:supportsVoice data-padding={text}>
  <input type="text" bind:this={hidden} class="hidden" />
  <textarea
    name="payload"
    placeholder={$_("components.textarea.placeholder", { default: "What’s your question?" })}
    bind:this={textarea}
    bind:value={text}
    on:keydown />
</div>
